import { HttpService } from 'services/http';

export const getBusinessUserIdDetails = (businessUserId) => HttpService.get(`/v2/employees/${businessUserId}`);

export const updateBusinessUserId = (businessUserId, requestPayload) => HttpService.put(`/v2/employees/${businessUserId}`, requestPayload);
